import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './taxoffice-filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Επωνυμία Δ.Ο.Υ'), fieldType: 'TEXT' },
    { fieldName: 'address', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'city', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getTaxoffices.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getTaxOffices: { data: recs, recordCount: data?.getTaxOffices?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export TaxOffices',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
